import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import {
  useIsAuthenticated,
  useAuthLoading,
  useHasMissingContact,
} from "@/hooks/auth/useAuth";
import LoginForm from "../components/auth/LoginForm";
import RegisterForm from "../components/auth/RegisterForm";

const AuthPage: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const isLoading = useAuthLoading();
  const hasMissingContact = useHasMissingContact();
  const location = useLocation();
  const from = location.state?.from || "/home";

  // If user is already logged in, redirect to home or the page they came from
  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  // If not logged in, show auth forms
  return (
    <Routes>
      <Route
        path="login"
        element={
          <LoginForm
            isLoading={isLoading}
            hasMissingContact={hasMissingContact}
          />
        }
      />
      <Route path="register" element={<RegisterForm isLoading={isLoading} />} />
    </Routes>
  );
};

export default AuthPage;
